import PropTypes from "prop-types";

export default PropTypes.shape({
  applications: PropTypes.arrayOf(PropTypes.shape({})),
  applicationsCount: PropTypes.number,
  createdAt: PropTypes.string,
  currency: PropTypes.shape({
    symbol: PropTypes.string,
    isoCode: PropTypes.string,
  }).isRequired,
  engagements: PropTypes.arrayOf(
    PropTypes.shape({
      status: PropTypes.string,
    })
  ),
  exclusive: PropTypes.bool,
  feedbackRequired: PropTypes.bool,
  hasNewApplications: PropTypes.bool,
  hasNewEngagements: PropTypes.bool,
  id: PropTypes.string,
  jobHubCandidatesPath: PropTypes.string,
  jobHubAgentsPath: PropTypes.string,
  jobHubJobProfilePath: PropTypes.string,
  jobType: PropTypes.string,
  location: PropTypes.string,
  numberOfPositions: PropTypes.number,
  placements: PropTypes.arrayOf(PropTypes.shape({})),
  placementFeePercent: PropTypes.number,
  publishedStatus: PropTypes.string,
  readApplicationsCount: PropTypes.number,
  reviewId: PropTypes.number,
  salary: PropTypes.number,
  status: PropTypes.string,
  title: PropTypes.string,
  unreadApplicationsCount: PropTypes.number,
});
